import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingExpenseAndIncome = _resolveComponent("SettingExpenseAndIncome")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_setting_document_from_mail = _resolveComponent("setting-document-from-mail")!
  const _component_SettingBobbeeCollect = _resolveComponent("SettingBobbeeCollect")!
  const _component_SettingSendingMailSMTP = _resolveComponent("SettingSendingMailSMTP")!
  const _component_setting_declaration = _resolveComponent("setting-declaration")!
  const _component_setting_others = _resolveComponent("setting-others")!
  const _component_setting_payment = _resolveComponent("setting-payment")!
  const _component_setting_workflow = _resolveComponent("setting-workflow")!
  const _component_setting_stock = _resolveComponent("setting-stock")!
  const _component_SettingManagementAuthorizations = _resolveComponent("SettingManagementAuthorizations")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "pa-2 mt-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SettingExpenseAndIncome, {
            config: _ctx.config,
            onUpdateProfile: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateProfile()))
          }, null, 8, ["config"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_setting_document_from_mail, {
            config: _ctx.config,
            companyId: _ctx.companyId,
            profileId: _ctx.profileId,
            forMyCompany: true,
            onUpdateProfile: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateProfile())),
            onOnUpdate: _ctx.refresh
          }, null, 8, ["config", "companyId", "profileId", "onOnUpdate"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SettingBobbeeCollect, {
            config: _ctx.config,
            companyId: _ctx.companyId,
            profileId: _ctx.profileId,
            forMyCompany: true,
            onUpdateProfile: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateProfile())),
            onOnUpdate: _ctx.refresh
          }, null, 8, ["config", "companyId", "profileId", "onOnUpdate"])
        ]),
        _: 1
      }),
      (_ctx.isAllowedToInvoice)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "4",
            class: "d-flex py-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SettingSendingMailSMTP, {
                ref: "setting-sending-mail-smtp",
                config: _ctx.config,
                profileId: _ctx.profileId,
                companyId: _ctx.companyId,
                readonly: _ctx.readonly,
                onUpdateProfile: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfile())),
                onOnUpdate: _ctx.refresh
              }, null, 8, ["config", "profileId", "companyId", "readonly", "onOnUpdate"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_setting_declaration, {
            config: _ctx.config,
            companyId: _ctx.companyId,
            incomeCategory: _ctx.companyIncomeCategory,
            onUpdateProfile: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateProfile()))
          }, null, 8, ["config", "companyId", "incomeCategory"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_setting_others, {
            config: _ctx.config,
            onUpdateProfile: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateProfile()))
          }, null, 8, ["config"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_setting_payment, {
            config: _ctx.config,
            companyId: _ctx.companyId,
            onUpdateProfile: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateProfile()))
          }, null, 8, ["config", "companyId"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_setting_workflow, {
            config: _ctx.config,
            companyId: _ctx.companyId,
            onUpdateProfile: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateProfile()))
          }, null, 8, ["config", "companyId"])
        ]),
        _: 1
      }),
      (_ctx.isAllowedToStock)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            cols: "4",
            class: "d-flex py-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_setting_stock, {
                config: _ctx.config,
                companyId: _ctx.companyId,
                onUpdateProfile: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateProfile()))
              }, null, 8, ["config", "companyId"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "d-flex py-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SettingManagementAuthorizations, {
            config: _ctx.config,
            companyId: _ctx.companyId,
            profileId: _ctx.profileId,
            forMyCompany: true,
            onUpdateProfile: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateProfile())),
            onOnUpdate: _ctx.refresh
          }, null, 8, ["config", "companyId", "profileId", "onOnUpdate"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}